import { symbolPreviewRegistry } from '@/features/_shared/symbol-preview-registry';

import { SelectAllToggle, SymbolCheckbox } from './SelectionSlots';

symbolPreviewRegistry.registerSelection(
  symbol => <SymbolCheckbox symbol={symbol} />,
  symbols => <SelectAllToggle symbols={symbols} />
);
